import type { DomainCheck } from "@onestore/api/domainSearch"
import type { DomainPromoLabel } from "@gatsby-plugin-domain-search/types"

export function getDomainPromoLabel(
  extension: DomainCheck.Extension
): DomainPromoLabel | null {
  return null
}
